// extracted by mini-css-extract-plugin
export default {"aside":"Aside_aside__0yb9e","aside__list":"Aside_aside__list__IK1Se","aside__link":"Aside_aside__link__Kvhrp","aside__link_active":"Aside_aside__link_active__SEAT8"};